// extracted by mini-css-extract-plugin
export default {"mainGrid":"MainGrid_mainGrid__5E5as"};